module.exports = "<div class=\"c-cms-text-input__label\">\n  \n</div>\n<div class=\"c-cms-text-input__input\">\n  <app-text-input></app-text-input>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cms-module/components/cms-text-input/cms-text-input.component.html
// module id = ./src/app/modules/cms-module/components/cms-text-input/cms-text-input.component.html
// module chunks = 9